// src/services/api.js
import axios from 'axios';

const BASE_URL = 'https://api.civicsetu.in';

// ── Axios instance ────────────────────────────────────────────
const api = axios.create({ baseURL: BASE_URL });

// Attach admin token to every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Redirect to login on 401 — but NOT during the login request itself
// If we redirect during login, wrong password causes page redirect instead of showing error
api.interceptors.response.use(
  res => res,
  err => {
    const isLoginRequest = err.config?.url?.includes('/api/admin/login');
    if (err.response?.status === 401 && !isLoginRequest) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      window.location.href = '/admin/login';  // FIX: was /login which does not exist
    }
    return Promise.reject(err);
  }
);

// ── Auth ──────────────────────────────────────────────────────
export const adminLogin = (email, password) =>
  api.post('/api/admin/login', { email, password });

export const verifyToken = () =>
  api.get('/api/admin/verify-token');

// ── Dashboard ─────────────────────────────────────────────────
export const getDashboard = () =>
  api.get('/api/admin/dashboard');

// ── Orders ───────────────────────────────────────────────────
export const getAllOrders = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.orderType)    params.append('orderType',    filters.orderType);
  if (filters.orderStatus)  params.append('orderStatus',  filters.orderStatus);
  if (filters.paymentStatus)params.append('paymentStatus',filters.paymentStatus);
  return api.get(`/api/admin/orders?${params}`);
};

export const getPendingPhysicalOrders = () =>
  api.get('/api/admin/orders/pending-physical');

export const getOrderById = (id) =>
  api.get(`/api/admin/orders/${id}`);

// FIX: changed { status } to { orderStatus } to match UpdateOrderStatusRequest DTO
export const updateOrderStatus = (id, status, trackingNumber) =>
  api.put(`/api/admin/orders/${id}/status`, { orderStatus: status, trackingNumber });

// ── Users ─────────────────────────────────────────────────────
export const getAllUsers = () =>
  api.get('/api/admin/users');

export const getUserById = (id) =>
  api.get(`/api/admin/users/${id}`);

export const toggleUserStatus = (id) =>
  api.put(`/api/admin/users/${id}/toggle-status`);

// ── Pricing ──────────────────────────────────────────────────
export const getPricing = () =>
  api.get('/api/admin/pricing');

export const updatePricing = (id, data) =>
  api.put(`/api/admin/pricing/${id}`, data);

export const getValidityConfig = () =>
  api.get('/api/admin/pricing/validity');

export const updateValidityConfig = (id, data) =>
  api.put(`/api/admin/pricing/validity/${id}`, data);

export const getGstConfig = () =>
  api.get('/api/admin/pricing/gst');

export const updateGstConfig = (id, data) =>
  api.put(`/api/admin/pricing/gst/${id}`, data);

// ── Webhook Logs ─────────────────────────────────────────────
// All recent webhook logs (no search needed)
export const getAllWebhookLogs = (status = '') =>
  api.get(`/api/admin/webhook-logs${status ? '?status=' + status : ''}`);

// Webhook logs for specific order
export const getWebhookLogs = (razorpayOrderId) =>
  api.get(`/api/admin/webhook-logs/${razorpayOrderId}`);

// All QR scans across platform
export const getAllScans = () =>
  api.get('/api/admin/scans');

export default api;
